import { KnownProjectDtoProjectType } from '@groundfloor-platform/mgmt-service-g-sdk';
import { SVGIconComponent } from '../icons/types';
import { ProjectTypeBusiness } from '../icons/ProjectType_Business.icon';
import { ProjectTypeCommercial } from '../icons/ProjectType_Commercial.icon';
import { ProjectFolder } from '../icons/ProjectType_Folder.icon';
import { ProjectTypeHubs } from '../icons/ProjectType_Hubs.icon';
import { ProjectTypeLink } from '../icons/ProjectType_Link.icon';
import { ProjectTypeNetwork } from '../icons/ProjectType_Network.icon';
import { ProjectTypePrecinct } from '../icons/ProjectType_Precinct.icon';
import { ProjectTypeProject } from '../icons/ProjectType_Project.icon';
import { ProjectTypeRegion } from '../icons/ProjectType_Region.icon';
import { ProjectTypeResidential } from '../icons/ProjectType_Residential.icon';
import { ProjectTypeRetailer } from '../icons/ProjectType_Retailer.icon';
import { ProjectTypeSettings } from '../icons/ProjectType_Settings.icon';
import { ProjectTypeShopping } from '../icons/ProjectType_Shopping.icon';
import { ProjectTypeStore } from '../icons/ProjectType_Store.icon';
import { ProjectTypeTheme } from '../icons/ProjectType_Theme.icon';

const PROJECT_TYPE_ICON: Record<string, SVGIconComponent> = {
  [KnownProjectDtoProjectType.Business]: ProjectTypeBusiness,
  [KnownProjectDtoProjectType.CommercialBuilding]: ProjectTypeCommercial,
  [KnownProjectDtoProjectType.Precinct]: ProjectTypePrecinct,
  [KnownProjectDtoProjectType.Project]: ProjectTypeProject,
  [KnownProjectDtoProjectType.ResidentialBuilding]: ProjectTypeResidential,
  [KnownProjectDtoProjectType.Retailer]: ProjectTypeRetailer,
  [KnownProjectDtoProjectType.Store]: ProjectTypeStore,
  [KnownProjectDtoProjectType.Network]: ProjectTypeNetwork,
  [KnownProjectDtoProjectType.Carrier]: ProjectTypeRegion,
  [KnownProjectDtoProjectType.Region]: ProjectTypeRegion,
  //  Alternative project types without SDK mapping used for logical grouping
  hubs: ProjectTypeHubs,
  link: ProjectTypeLink,
  settings: ProjectTypeSettings,
  shopping: ProjectTypeShopping,
  theme: ProjectTypeTheme
};

export function ProjectIcon({ projectType }: { projectType?: string }) {
  const Icon = (projectType && PROJECT_TYPE_ICON[projectType]) || ProjectFolder;
  return <Icon />;
}
